<template>
    <company-expo-program-list v-bind="{ tab }" v-if="userType == COMPANY.value" />
    <person-expo-program-list v-bind="{ tab }" v-else-if="userType == PERSON.value" />
</template>

<script>
import { mapState } from "vuex";
import { USER_TYPES } from "@/assets/variables";

import CompanyExpoProgramList from "@/components/dashboard/company/expo/program/expo-program-list.vue";
import PersonExpoProgramList from "@/components/dashboard/person/expo/program/expo-program-list.vue";

export default {
    components: {
        CompanyExpoProgramList,
        PersonExpoProgramList,
    },
    props: {
        tab: { type: String },
    },
    data: () => ({
        ...USER_TYPES,
    }),
    computed: {
        ...mapState({ userType: (store) => store.payload?.userType }),
    },
};
</script>

<style></style>
